import React from "react";
import "./MapLocations.css"
import { Link, useParams } from "react-router-dom"
import { prepareStageEntry, getDefaultSpawn } from "../../config/worldTransitions";

function Village() {
    const { id } = useParams()

    return(
        <div className="map-location text-center special villageDiv">
            <img src={require("../../images/mapVillage.png")} alt="Village" className="village" />
            <Link className="stage-link map-location__control" to={"/village/" + id} onClick={() => prepareStageEntry(id, "village", getDefaultSpawn("village"))}>Village</Link>
        </div>
    )
}

export default Village;